// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"0fd96d88","891":"09ee3a6d"}[chunkId] + ".chunk.css";
};